import React, { Fragment } from 'react';
import StatefulMaskedInput from './maskedInput';
import SC, { InputContainer, IconButtonContainer, IconButton, HintMessage, CloseIcon } from './styles';
import { noop } from '../../helpers';
var TextField = function TextField(props) {
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(InputContainer, null, props.numberFormat === true ? /*#__PURE__*/React.createElement(StatefulMaskedInput, {
    ref: props.ref,
    disabled: !props.isEditable || props.disabled,
    id: props.id,
    autoComplete: props.autoComplete,
    className: props.className,
    form: props.form,
    maxLength: props.maxLength,
    name: props.name,
    pattern: props.pattern,
    placeholder: props.placeholder,
    size: props.size,
    type: props.type,
    value: props.value,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onClick: props.onClick,
    onFocus: props.onFocus,
    onSelect: props.onSelect,
    onKeyDown: props.onKeyDown,
    onKeyPress: props.onKeyPress,
    onKeyUp: props.onKeyUp,
    isEditable: props.isEditable,
    showClear: props.showClear,
    rightIcon: props.rightIcon,
    validation: props.error ? 'danger' : props.validation,
    "data-testid": props['data-testid']
  }) : /*#__PURE__*/React.createElement(SC.Input, {
    id: props.id,
    autoComplete: props.autoComplete,
    className: props.className,
    disabled: !props.isEditable || props.disabled,
    form: props.form,
    maxLength: props.maxLength,
    name: props.name,
    pattern: props.pattern,
    placeholder: props.placeholder,
    size: props.size,
    type: props.type,
    value: props.value,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onClick: props.onClick,
    onFocus: props.onFocus,
    onSelect: props.onSelect,
    onKeyDown: props.onKeyDown,
    onKeyPress: props.onKeyPress,
    onKeyUp: props.onKeyUp,
    isEditable: props.isEditable,
    showClear: props.showClear,
    rightIcon: props.rightIcon,
    validation: props.error ? 'danger' : props.validation,
    "data-testid": props['data-testid']
  }), props.showClear && !props.disabled && props.isEditable && /*#__PURE__*/React.createElement(IconButtonContainer, {
    onClick: props.onClear,
    stickyRight: props.rightIcon && props.showClear
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(CloseIcon, null))), props.rightIcon && /*#__PURE__*/React.createElement(IconButtonContainer, null, /*#__PURE__*/React.createElement(IconButton, null, props.rightIcon))), props.hintMessage && /*#__PURE__*/React.createElement(HintMessage, {
    validation: props.validation
  }, props.hintMessage));
};
TextField.defaultProps = {
  type: 'text',
  isEditable: true,
  showClear: false,
  onBlur: noop,
  onChange: noop,
  onClear: noop,
  onClick: noop,
  onFocus: noop,
  onSelect: noop,
  onKeyDown: noop,
  onKeyPress: noop,
  onKeyUp: noop,
  numberFormat: false
};
TextField.legacyName = 'ux-input-box';
export default TextField;